import Cookies from 'js-cookie'

const cookieName = (name) => `tr-ndsbzl-${name}`

/**
 * 设置cookie
 * @param {string} name
 * @param value
 * @returns 设置对应name的cookie
 * */
export function setCookie(name, value) {
  Cookies.set(cookieName(name), value)
}

/**
 * 获取cookie
 * @param {string} name
 * @returns {object|array|number|boolean|null|undefined} 根据name从cookie中获取数据
 * */
export function getCookie(name) {
  return Cookies.get(cookieName(name))
}

/**
 * 移除cookie
 * @param {string} name
 * */
export function removeCookie(name) {
  Cookies.remove(cookieName(name))
}
